import { createContext, useContext, useState } from 'react';
import AlertPop from '../components/AlertPop';

const AlertContext = createContext();
export const useAlert = () => useContext(AlertContext);

export function AlertProvider({ children }) {
  const [alert, setAlert] = useState({
    messages: [],
    type: '',
    visible: false,
    onConfirm: null,
  });

  const showAlert = (messages, type = 'info', onConfirm = null) => {
    setAlert({ messages, type, visible: true, onConfirm });
  };

  const clearAlert = () => {
    setAlert({ messages: [], type: '', visible: false, onConfirm: null });
  };

  return (
    <AlertContext.Provider value={{ alert, showAlert, clearAlert }}>
      {children}
      {alert.visible && (
        <AlertPop
          alertMessages={alert.messages}
          alertType={alert.type}
          onClose={clearAlert}
          onConfirm={alert.onConfirm}
        />
      )}
    </AlertContext.Provider>
  );
}